import React from 'react'
import {useSelector} from 'react-redux' 
import { Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { userlog } from '../features/auth';
import { useLocation } from 'react-router-dom';
import { setuserid ,setuserdata } from '../features/auth';
import { cartItem } from '../features/cartdata';

const ProtectedRoute = ({children}) => {
   const dispatch = useDispatch()
   const location = useLocation()
   const {userlogedin} = useSelector((state)=>state.auth);
   let id = localStorage.getItem('id')
   
   if(location.pathname.includes('/prod') || location.pathname.includes('/Shop') || location.pathname.includes('/brand')
      || location.pathname === '/' || location.pathname === '/login'
   ){ 
      
      let token = localStorage.getItem('token')
      if(token){
         dispatch(userlog(true))
         dispatch(setuserid(id)) 
         dispatch(setuserdata(localStorage.getItem('userdata'))) 
         dispatch(cartItem(localStorage.getItem('cart')));
      }else{
         return children
      }
   }
   let token = localStorage.getItem('token')
   if(token){
      dispatch(userlog(true))
      dispatch(setuserid(id))
      dispatch(setuserdata(localStorage.getItem('userdata'))) 
      dispatch(cartItem(localStorage.getItem('cart')));
   }
    if(userlogedin === false){
       return <Navigate to='/login'/>
    }
     return children
}

export default ProtectedRoute